(() => {
  function enhance() {
    document.querySelectorAll('[data-bwct-faq]').forEach(root => {
      if (root.dataset.enhanced) return;
      root.dataset.enhanced = 'true';
      const input = root.querySelector('[data-bwct-search]');
      const clear = root.querySelector('[data-bwct-clear]');
      const empty = root.querySelector('[data-bwct-empty]');
      const questions = [...root.querySelectorAll('[data-bwct-question]')];
      const groups = [...root.querySelectorAll('[data-bwct-faq-group]')];
      function filter() {
        const query = input.value.trim().toLocaleLowerCase();
        let matches = 0;
        questions.forEach(item => {
          item.hidden = Boolean(query) && !item.textContent.toLocaleLowerCase().includes(query);
          item.open = Boolean(query) && !item.hidden;
          if (!item.hidden) matches++;
        });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-bwct-question]')].some(item => !item.hidden); });
        empty.hidden = matches > 0;
        clear.hidden = !query;
      }
      input.addEventListener('input', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      root.querySelectorAll('.bwct-faq-nav a[href^="#"]').forEach(link => link.addEventListener('click', () => { input.value = ''; filter(); }));
    });
    document.querySelectorAll('[data-bwct-play]').forEach(button => {
      if (button.dataset.enhanced) return;
      button.dataset.enhanced = 'true';
      const film = button.closest('figure').querySelector('video');
      button.addEventListener('click', async () => {
        if (film.paused) { try { await film.play(); } catch { return; } }
        else film.pause();
      });
      const state = () => { button.textContent = film.paused ? button.dataset.play : button.dataset.pause; button.setAttribute('aria-pressed', String(!film.paused)); };
      film.addEventListener('play', state); film.addEventListener('pause', state); film.addEventListener('ended', state);
      state();
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
